import React, { useEffect, useRef, useState } from 'react'
import { IEnquiryDetail, IRecommenedLinkInfo } from '../../../models/Enquiry'
import Conditional from '../../common/Conditional'
import EnquiryDetailRow from './helpers/EnquiryDetailRow'
import '../Enquiries.css'
import { useHistory } from 'react-router-dom'
import { Button } from 'semantic-ui-react'

export interface IEnquiryDetailProps {
  data: IEnquiryDetail
}

const EnquiryInboundPhoneDetail = (props: IEnquiryDetailProps) => {
  const mountedRef = useRef(false)
  const history = useHistory()
  const [data, setData] = useState<IEnquiryDetail>()

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      setData(props.data)
    }
    return () => {
      mountedRef.current = false
    }
  }, [props.data])

  const backtoEnquiries = () => {
    history.push('/my-account/enquiries')
  }

  return (
    <Conditional if={data}>
      <table>
        <thead>
          <tr>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <EnquiryDetailRow
            title="Status"
            value={data?.status}
            showDefaultAnswer={false}
          />
          <EnquiryDetailRow
            title="Customer registration number (CRN)"
            value={data?.crn}
            showDefaultAnswer={false}
          />
         <Conditional if = {!data?.enquiryTypeLevel1?.includes('Criminalisingunderpayments')} >
          <EnquiryDetailRow
            title="Enquiry type level 1"
            value={data?.enquiryTypeLevel1}
            showDefaultAnswer={false}
          />
          <EnquiryDetailRow
            title="Enquiry type level 2"
            value={data?.enquiryTypeLevel2}
            showDefaultAnswer={false}
          />
        </Conditional>
        <Conditional if = {data?.enquiryTypeLevel1?.includes('Criminalisingunderpayments')} >
         <tr></tr> 
        </Conditional>
          <EnquiryDetailRow
            title="Channel"
            value={data?.channel}
            showDefaultAnswer={false}
          />
          <tr>
            <td>Recommended links</td>
            <td colSpan={2}>
              <ul>
                {data?.recommendedLinks?.map(
                  (link: IRecommenedLinkInfo, index) => {
                    return (
                      <li key={index}>
                        <a target="_blank" href={link.url} rel="noreferrer">
                          {link.name}
                        </a>
                      </li>
                    )
                  }
                )}
              </ul>
            </td>
          </tr>
        </tbody>
        <tfoot></tfoot>
      </table>
      <Button className="is-primary" onClick={() => backtoEnquiries()}>
        Return to enquiry list
      </Button>
    </Conditional>
  )
}
export default EnquiryInboundPhoneDetail
